import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n/index'
import APIS from './api/api'
Vue.prototype.APIS = APIS
// import Calendar from 'vue2-datepick'; //日期控件
// Vue.use(Calendar);//日期控件
// 在入口文件中（main.js），导入组件库
// import DatePicker from "@/components/main/datePicker";
// Vue.component("DatePicker")
// import VConsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new VConsole();

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
